import { render } from "./EventCategories.vue?vue&type=template&id=bc9f5e66&scoped=true"
import script from "./EventCategories.vue?vue&type=script&lang=js"
export * from "./EventCategories.vue?vue&type=script&lang=js"

import "./EventCategories.vue?vue&type=style&index=0&id=bc9f5e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9f5e66"]])

export default __exports__